import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Typography, Popover, IconButton } from "@mui/material";
import { TbWaveSawTool } from "react-icons/tb";
import { PALETTE } from "../Theme/Palette";

function Status() {
  const { data } = useSelector((state) => state.UserCurrentState);
  const [convertedStatus, setConvertedStatus] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const convertStatus = useCallback((status, colors) => {
    if (!status.parent) {
      let colorCodes = colors.pop();
      return [
        {
          id: status.id,
          code: status.code,
          name: status.name,
          style: {
            color: colorCodes.background,
            color: colorCodes.font,
          },
        },
      ];
    }
    let parent = convertStatus(status.parent, colors);
    let colorCodes = colors.pop();
    return [
      ...parent,
      {
        id: status.id,
        code: status.code,
        name: status.name,
        style: {
          backgroundColor: colorCodes.background,
          color: colorCodes.font,
        },
      },
    ];
  }, []);

  useEffect(() => {
    let temp = convertStatus(data, [...PALETTE.Status.chips]);
    setConvertedStatus(temp);
  }, [data, convertStatus, setConvertedStatus]);

  return (
    <Box sx={{ backgroundColor: "transparent" }}>
      <Box
        display={{ xs: "none", sm: "none", md: "flex", lg: "flex" }}
        flexDirection="row-reverse"
        sx={{
          backgroundColor: PALETTE.Status.chips[2].background,
          borderRadius: "20px",
          position: "relative",
        }}
        padding={0.5}
      >
        {convertedStatus.map((item, index) => (
          <Typography
            key={index}
            sx={{
              ...item.style,
              borderRadius: "10rem",
              zIndex: 5,
              cursor: "default",
              userSelect: "none",
            }}
            paddingX={1}
            paddingY={0.5}
            marginLeft={convertedStatus.length - 1 !== index ? 1 : 0}
          >
            {item.name}
          </Typography>
        ))}
      </Box>
      <IconButton
        onClick={handleClick}
        sx={{
          padding: 0.5,
          display: { xs: "flex", sm: "flex", md: "none", lg: "none" },
          backgroundColor: PALETTE.Status.chips[1].background,
          color: PALETTE.Status.chips[0].font,
        }}
      >
        <TbWaveSawTool />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        sx={{ "& .MuiPaper-root": { backgroundColor: "transparent", boxShadow: "none" } }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box
          display={{ xs: "flex", sm: "flex", md: "none", lg: "none" }}
          flexDirection="column"
          sx={{
            backgroundColor: PALETTE.Status.chips[2].background,
            borderRadius: "20px",
            position: "relative",
          }}
          padding={0.5}
        >
          {convertedStatus.map((item, index) => (
            <Typography
              key={index}
              sx={{
                ...item.style,
                borderRadius: "10rem",
                zIndex: 5,
                cursor: "default",
                userSelect: "none",
              }}
              paddingX={1}
              paddingY={0.5}
              marginLeft={convertedStatus.length - 1 !== index ? 1 : 0}
            >
              {item.name}
            </Typography>
          ))}
        </Box>
      </Popover>
    </Box>
  );
}

export default Status;
